import React from "react";
import { Box } from "@mui/material";
import BottomNav from "./BottomNav";

export const NAV_HEIGHT = 56;

// Wraps the two footer-tab pages (Pickup, My Deliveries) with the persistent
// bottom nav; Login renders standalone.
export default function MainLayout({ children }) {
  return (
    <Box sx={{ pb: `${NAV_HEIGHT}px` }}>
      {children}
      <BottomNav />
    </Box>
  );
}
